"use client";
import React from 'react';
import { useLocation } from '../../lib/routeUtil';
import { usePostBySlug } from './usePost';
import PostsPageWrapper from "./PostsPage/PostsPageWrapper";
import Loading from "../vulcan-core/Loading";
import Error404 from "../common/Error404";

const PostsSingleSlug = ({slug}: {slug: string}) => {
  const { query } = useLocation();
  const version = query?.revision
  const { post, loading } = usePostBySlug({ slug });
  
  if (post) {
    return <PostsPageWrapper documentId={post._id} sequenceId={null} version={version} />
  } else {
    return loading ? <Loading/> : <Error404 />
  }
};

export default PostsSingleSlug;


